import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { CopyExecutionMode } from '@flipster/apis/v1/copy-trade/types';
import { FormattedMessage } from '@flipster/i18n';
import { createSegmentedControl } from '@flipster/react/design-system/segmented-control';

import { copyTradingSettingsBunja } from '../../state';

const SegmentedControl = createSegmentedControl<CopyExecutionMode>();

export const ExecutionModeSection = () => {
  const { copyExecutionModeAtom, setCopyExecutionMode, fixedMultiplierRedDotAtom } = useBunja(copyTradingSettingsBunja);
  const copyExecutionMode = useAtomValue(copyExecutionModeAtom);
  const showRedDot = useAtomValue(fixedMultiplierRedDotAtom);

  return (
    <SegmentedControl value={copyExecutionMode} onChange={setCopyExecutionMode}>
      <SegmentedControl.Item value='FIXED_RATIO'>
        <FormattedMessage id='Copy.r260205.Fixed_ratio' />
      </SegmentedControl.Item>
      <SegmentedControl.Item value='FIXED_MULTIPLIER' redDot={showRedDot}>
        <FormattedMessage id='Copy.r260205.Fixed_multiplier' />
      </SegmentedControl.Item>
    </SegmentedControl>
  );
};
